import { getImage } from "../../utils/cloudinarySizing";
import { useState } from "react";
import { cropAndResizeProfileImage } from "../../utils/imageUtils";

const EditProfileModal = ({
    isOpen,
    onClose,
    profileData,
    editForm,
    setEditForm,
    handleProfileUpdate,
}) => {
    const [previewPhoto, setPreviewPhoto] = useState(null);

    if (!isOpen) return null;

    const handleClose = () => {
        if (previewPhoto) {
            URL.revokeObjectURL(previewPhoto);
        }

        setPreviewPhoto(null);
        onClose();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setEditForm((prev) => ({
            ...prev,
            photo_original: file,
        }));

        cropAndResizeProfileImage(file, (preview) => {
            setPreviewPhoto(preview);
        });
    };

    const currentImage =
        previewPhoto ||
        profileData?.profile?.photo_original ||
        "/servspace-default-150x150.png";

    return (
        <div className="edit-overlay" onClick={handleClose}>
            <div className="edit-content" onClick={(e) => e.stopPropagation()}>

                <button className="modal-close-button" onClick={handleClose}>
                    &times;
                </button>

                <h2 className="modal-title">Edit Profile</h2>

                <form onSubmit={handleProfileUpdate} className="modal-form">

                    {/* PROFILE PHOTO */}
                    <div className="form-group">
                        <label>Profile Photo:</label>

                        <div className="profile-preview-container">
                            <img
                                src={getImage(currentImage, "avatar_sm")}
                                alt="Profile"
                                className="profile-image-preview"
                            />
                        </div>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                    </div>

                    {/* NAME */}
                    <div className="form-group">
                        <label htmlFor="name">Display Name:</label>

                        <input
                            id="name"
                            type="text"
                            value={editForm.name}
                            onChange={(e) =>
                                setEditForm({
                                    ...editForm,
                                    name: e.target.value,
                                })
                            }
                            required
                        />
                    </div>

                    {/* BUTTONS */}
                    <div className="modal-buttons">
                        <button type="submit" className="save-btn">
                            Save
                        </button>

                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default EditProfileModal;